var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEndQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7826 22.6351C16.7826 22.2426 16.7515 21.9137 16.7968 21.5961C16.8159 21.461 16.9736 21.316 17.103 21.2346C17.7304 20.8364 18.4116 20.5181 18.9965 20.0612C20.8893 18.5815 22.0111 16.6335 22.0726 14.1028C22.0896 13.3848 21.8251 13.2045 21.2224 13.4853C19.4803 14.293 17.6066 13.8191 16.6072 12.3182C15.5172 10.6801 15.6707 8.49869 16.9771 7.0685C18.645 5.2422 21.3908 5.18703 23.2843 6.93269C24.4181 7.97811 24.9571 9.32767 25.0915 10.8633C25.542 16.0062 22.9624 20.2458 18.2666 22.1082C17.8019 22.2921 17.3258 22.4434 16.7826 22.6351Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49453 22.6351C6.49453 22.2426 6.46341 21.9137 6.50867 21.5961C6.52777 21.461 6.6855 21.316 6.81494 21.2346C7.44233 20.8364 8.12348 20.5181 8.70843 20.0612C10.6012 18.5815 11.723 16.6335 11.7846 14.1028C11.8015 13.3848 11.537 13.2045 10.9344 13.4853C9.19223 14.293 7.31855 13.8191 6.31911 12.3182C5.22914 10.6801 5.38262 8.49869 6.68904 7.0685C8.35689 5.2422 11.1027 5.18703 12.9962 6.93269C14.13 7.97811 14.669 9.32767 14.8034 10.8633C15.2539 16.0062 12.6744 20.2458 7.97848 22.1082C7.51377 22.2921 7.03775 22.4434 6.49453 22.6351Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndQuote);
export default __webpack_public_path__ + "static/media/end-quote.8badd7827fad86ca7eb406b1e51fc6ac.svg";
export { ForwardRef as ReactComponent };